import { TARGET } from "../constants/target.qwik.mjs";
import { getEventHandlerName } from "./event-handler-name.qwik.mjs";
import { createEventHandler } from "./get-block-actions-handler.qwik.mjs";
function getBlockActions(options) {
  const obj = {};
  const optionActions = options.block.actions ?? {};
  for (const key in optionActions) {
    if (!optionActions.hasOwnProperty(key))
      continue;
    const value = optionActions[key];
    let eventHandlerName = getEventHandlerName(key);
    if (options.stripPrefix)
      switch (TARGET) {
        case "vue":
          eventHandlerName = eventHandlerName.replace("v-on:", "");
          break;
        case "svelte":
          eventHandlerName = eventHandlerName.replace("on:", "");
          break;
      }
    obj[eventHandlerName] = createEventHandler(value, options);
  }
  return obj;
}
export {
  getBlockActions
};
